module.exports = __webpack_public_path__ + "media/images/favicons/ms-icon-310x310-0f9d7d03f870e8e25a9e9e80a64103d2.png";